/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Organization({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Organization_svg__a)"><path fillRule="evenodd" d="M8 .4a2.6 2.6 0 1 0 0 5.2A2.6 2.6 0 0 0 8 .4M6.6 3a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0M3 5.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2M1.6 8a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0M13 5.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2M11.6 8a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0M8 10.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2M6.6 13a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0" clipRule="evenodd" /><path d="M1.1 2.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0M12.1 2.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0M12.1 13.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0M1.1 13.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0" /></g><defs><clipPath id="Organization_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;